import { isSofiaHomeSection } from "./sofiaHome"

const ASSISTANT_PANEL_EXCLUDED_ROUTE_PREFIXES = [
  "/signin",
  "/signup",
  "/signup-welcome",
  "/sso-callback",
  "/select-org",
  "/reactivate",
  "/billing",
  "/marketplace",
  "/integrations",
  "/agent-training",
  "/tts-benchmarks",
  "/404",
  "/home",
  "/[slug]/home",
  "/admin",
  "/[slug]/admin",
  "/settings",
  "/[slug]/settings",
  "/[slug]/onboarding",
  "/[slug]/launch-eval",
  "/[slug]/templates/new",
  "/[slug]/simulations",
  "/[slug]/simulated/results",
  "/shared/notebooks",
  "/shared/reports/[report_id]/results",
  "/shared/runs/[run_id]/results",
] as const

const ASSISTANT_PANEL_EXCLUDED_EXACT_ROUTES = [
  "/",
  "/[slug]/review",
  "/[slug]/review/assignments/[projectId]",
] as const

/**
 * The single route policy for whether the Sofia Assistant Panel may be shown.
 * Full-page Sofia is a separate presentation and still mounts on Home routes;
 * this policy governs the panel entry point, shortcut, auto-open behavior,
 * page summaries, and docked/overlay presentation.
 */
export function isSofiaPanelAvailable({
  pathname,
  asPath,
}: {
  pathname: string
  asPath: string
}): boolean {
  if (isSofiaHomeSection(asPath)) {
    return false
  }

  if (
    ASSISTANT_PANEL_EXCLUDED_EXACT_ROUTES.some((route) => pathname === route)
  ) {
    return false
  }

  return !ASSISTANT_PANEL_EXCLUDED_ROUTE_PREFIXES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  )
}
